<template>
	<div id="compatibility-page">

		<section class="banner-section">
			<div class="container oversized-container">
				<div class="row align-items-center">
					<div class="col-12 col-title">
						<h5>Compatibilidad</h5>
						<!-- <h6>*Banda del espectro de 700 MHz para México.</h6> -->
					</div>
				</div>
			</div>
		</section>

		<section class="container content-section">
			<div class="row">
				<div class="col-12 col-title-s1">
					<h3 class="title" style="font-size: 1.5rem;">Equipos compatibles</h3>
				</div>
				<div class="col-lg-10 text-justify offset-lg-1">
					<p>
						Para que nuestra red funcione de manera adecuada, se requiere contar con equipos
						compatibles.<br />
						Todos los equipos que han sido importados de forma legal a nuestro país por decreto federal
						cuenta con la frecuencia 700 mhz que opera sobre la banda 28, la cual usará BLACKFON.
					</p>
					<ul class="pl-3">
						<li>Un equipo es compatible cuando opera sobre la banda 28, con una frecuencia de 700mhz.</li>
						<li>Cuenta con tecnología VoLTE.</li>
					</ul>
				</div>

				<!-- <div class="col-12 col-title-s1"> -->
					<!-- <h3 class="title">Compatibilidad</h3> -->
				<!-- </div> -->

				<!-- <div class="col-12 col-tabs"> -->
					<!-- <div class="row justify-content-center"> -->
						<!-- <router-link class="box-tab" to="/compatibilidad"> -->
							<!-- <div>Verificación por IMEI</div> -->
						<!-- </router-link> -->
						<!-- 
							<router-link class="box-tab" to="/compatibilidad/dispositivos">
								<div>Dispositivos compatibles</div>
							</router-link> 
						-->
					<!-- </div> -->
				<!-- </div> -->

				<router-view></router-view>

			</div>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
}
</script>
